import { LitElement, html } from 'lit';
import { FsIcon } from '@cof/fs-icon-wc/fs-icon.js';
import {
  fs24Home,
  fs24HomeFilled,
  fs24PlusCircle,
  fs24PlusCircleFilled,
} from '@cof/fs-icons';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../../shared/services/debug.service.js';
import '@cof/fs-radio-wc/fs-radio.js';
import { style } from './toggle-share-address.style.js';
import { globalStyle } from '../../../../global-styles.style.js';
import { ApplicationService } from '../../../../services/application.service.js';
import { stratum } from '../../../../../constants/stratum.js';

export class RefiToggleShareAddressComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiToggleShareAddressComponent');
    this.toggleShareAddressValue = undefined;
    this.loading = false;
    this.isSameAddress = undefined;

    const icons = [
      fs24Home,
      fs24HomeFilled,
      fs24PlusCircle,
      fs24PlusCircleFilled,
    ];
    for (const icon of icons) {
      FsIcon.add(icon);
    }
  }

  static properties = {
    isSameAddress: {
      type: Boolean,
      reflect: true,
      attribute: 'is-same-address',
    },
  };

  static styles = [style, globalStyle];

  firstUpdated() {
    this.addCustomPadding();
  }

  addCustomPadding() {
    setTimeout(() => {
      const toggleYes = this.shadowRoot.getElementById('toggleShareAddressYes');
      const toggleNo = this.shadowRoot.getElementById('toggleShareAddressNo');

      if (toggleNo) {
        toggleNo.renderRoot.children[1].setAttribute('style', 'padding:1rem');
      }
      if (toggleYes) {
        toggleYes.renderRoot.children[1].setAttribute('style', 'padding:1rem');
      }
    }, 0);
  }

  render() {
    return html`<fs-choice-button-group
      direction="row"
      field-label="Does your co-borrower share your address?"
    >
      <fs-choice-button
        id="toggleShareAddressNo"
        name="toggleShareAddress"
        type="radio"
        alignment="center"
        .labelText="${html`<span>Yes, we share</span><br /><span
            >an address</span
          >`}"
        value="TRUE"
        ?selected="${this.isSameAddress === true}"
        data-e2e-ref="toggleShareAddressNo"
        @click="${this.sameAddressChange}"
      >
        ${this.isSameAddress === true
          ? html`<fs-icon
              slot="choice-button-icon"
              icon="fs-24-home-filled"
            ></fs-icon>`
          : html`<fs-icon
              slot="choice-button-icon"
              icon="fs-24-home"
            ></fs-icon>`}
      </fs-choice-button>

      <fs-choice-button
        id="toggleShareAddressYes"
        name="toggleShareAddress"
        type="radio"
        alignment="center"
        .labelText="${html`<span>No, they have a</span><br /><span
            >different address</span
          >`}"
        value="FALSE"
        ?selected="${this.isSameAddress === false}"
        data-e2e-ref="toggleShareAddressYes"
        @click="${this.sameAddressChange}"
      >
        ${this.isSameAddress === false
          ? html`<img
                slot="choice-button-icon"
                src="assets/fs-24-houses-filled.svg"
                alt="FS House Filled"
            ></img>`
          : html`<img
                slot="choice-button-icon"
                src="assets/fs-24-houses.svg"
                alt="FS house"
            ></img>`}
      </fs-choice-button>
    </fs-choice-button-group>`;
  }

  sameAddressChange(ev) {
    this.isSameAddress = ev.target.value === 'TRUE';

    stratum.publishTag(TagKey.ADDRESS_PAGE_CO_BORROWER_ADDRESS, {
      replacements: {
        value: this.isSameAddress ? 'sameAddress' : 'differentAddress',
      },
    });

    this.dispatchEvent(
      new CustomEvent('toggle-same-address', {
        detail: {
          isSameAddress: this.isSameAddress,
        },
      })
    );
  }

  saveToApplication() {
    if (
      ApplicationService.Application.primaryApplicant &&
      typeof this.isSameAddress !== 'undefined'
    ) {
      ApplicationService.Application = {
        ...ApplicationService.Application,
        primaryApplicant: {
          ...ApplicationService.Application.primaryApplicant,
          isSameAddress: this.isSameAddress,
        },
      };
      this.requestUpdate();
    }
  }
}

customElements.define(
  'refi-share-address-toggle',
  RefiToggleShareAddressComponent
);
